import { LandType, } from "@loanlink-nl/model-hdn/OfferteAanvraag";
export function createMappingError(field, message, originalValue) {
    return { field, message, originalValue };
}
export function createMappingWarning(field, message, originalValue) {
    return { field, message, originalValue };
}
export function parseAmount(amount) {
    if (typeof amount === "number")
        return amount;
    if (typeof amount === "string") {
        const cleaned = amount.replace(/[^\d.-]/g, "");
        const parsed = Number.parseFloat(cleaned);
        return Number.isNaN(parsed) ? undefined : parsed;
    }
    return undefined;
}
export function mapGender(gender) {
    if (!gender)
        return undefined;
    const normalized = gender.toLowerCase();
    if (normalized === "male" || normalized === "m" || normalized === "man") {
        return "01 M";
    }
    if (normalized === "female" || normalized === "f" || normalized === "vrouw") {
        return "02 V";
    }
    if (normalized === "x") {
        return "03 X";
    }
    return undefined;
}
export function mapIso3166(alpha2Code) {
    const countryKeys = Object.keys(LandType);
    const matchingCountry = countryKeys.find((key) => key.toUpperCase().startsWith(`${alpha2Code.toUpperCase()} `));
    return matchingCountry;
}
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
export function isValidPhoneNumber(phone) {
    const phoneRegex = /^[+]?[0-9\s\-()]{8,}$/;
    return phoneRegex.test(phone);
}
export function isValidIBAN(iban) {
    const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/;
    return ibanRegex.test(iban.replace(/\s/g, ""));
}
